import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CV_Wizard from './pages/CV_Wizard';
import LinkedIn_Wizard from './pages/LinkedIn_Wizard';
import './App.css';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/cv-wizard" element={<CV_Wizard />} />
                <Route path="/linkedin-wizard" element={<LinkedIn_Wizard />} />
            </Routes>
        </Router>
    );
}

export default App;
